// extracted by mini-css-extract-plugin
export default {"bngDomainSuggestionsRoot":"AvrAfe","bngFirstRecoTitle":"snYddx","bngMobileStepEnter":"Tn2IMS","bngStepSlideIn":"RHsKcN","bngDomainSuggestionsHeading":"wDRLXB"};